<template>
  <div class="the-navbar esep-black-bg d-flex">
    <div class="col-3 d-flex justify-content-start esep-black-bg py-1 px-3">
      <b-button v-b-toggle.sidebar-1 class="esep-black-bg" v-if="$keycloak.authenticated"><b-icon icon="list"
          aria-hidden="true"></b-icon></b-button>
    </div>
    <b-sidebar id="sidebar-1" header-class="the-sidebar " body-class="the-sidebar" title="Επιλογές Εφαρμογής" backdrop
      shadow width="440px">
      <nav class="mb-3 px-3">
        <b-nav vertical>
          <b-nav-item v-bind:href="this.routes.home" link-classes="white-link row-height" v-if="!this.userInfo.onlySelf">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="house-door" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold"> {{ $t("message.home") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.member.edit + '/' + this.userInfo.id"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="person-circle" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.showMe") }}</label>
              </div>
            </div>
          </b-nav-item>

          <b-nav-item v-bind:href="this.routes.achievement.progress + '/' + this.userInfo.id"
            v-if="this.userInfo.onlySelf" link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="person-circle" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.showMyProgress") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.users.management" v-if="this.isAdmin" link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="person-circle" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.roleManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.member.management" v-if="this.isAdmin ||
            this.isUnitAdmin ||
            this.isFinanceAdmin ||
            this.isUnitMod ||
            this.isUnitViewer ||
            this.isTroopAdmin ||
            this.isBranchCommissioner
            " link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="people" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.memberManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.unit.management"
            v-if="this.isAdmin || this.isUnitAdmin || this.isFinanceAdmin || this.isUnitMod || this.isUnitViewer"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="shop" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.unitManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.census.add"
            v-if="this.isAdmin || this.isUnitAdmin || this.isFinanceAdmin || this.isUnitMod || this.isUnitViewer"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="card-checklist" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.censusManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.licenses.active"
            v-if="this.isAdmin || this.isUnitAdmin || this.isUnitMod || this.isUnitViewer || this.isFinanceAdmin || this.isTrainingAdmin || this.isTrainMod"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="list-stars" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.licenseManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.licenses.pending"
                      v-else-if="!this.showTraining"
                      link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="list-stars" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.licenseManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.support.active"
            v-if="this.isAdmin || this.isUnitAdmin || this.isFinanceAdmin || this.isUnitMod || this.isUnitViewer"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="person-lines-fill" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.supportManagement") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.conference.management" v-if="this.isAdmin"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="archive" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.conferenceManagement") }}</label>
              </div>
            </div>
          </b-nav-item>

          <b-nav-item v-bind:href="this.routes.training.progress + '/' + this.userInfo.id + '/progress'"
            v-if="!this.showTraining" link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="patch-check" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.trainingMine") }}</label>
              </div>
            </div>
          </b-nav-item>

          <b-nav-item v-bind:href="this.routes.training.trainings"
            v-if="this.isAdmin || this.isTrainingAdmin || this.isTrainMod || this.seeTrain"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="folder2-open" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.training") }}</label>
              </div>
            </div>
          </b-nav-item>

          <b-nav-item v-bind:href="this.routes.excursions.excursionActivities"
            v-if="this.isAdmin || this.isUnitAdmin || this.isUnitMod || this.isUnitViewer || this.isTroopAdmin || this.isCommissionPresident || this.isCaptain || this.isExcursionViewer || this.isAffairsCommissioner || this.isNavyCommissioner || this.isBranchCommissioner"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="compass" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.excursionActivities") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.jamboree.submit"
            v-if="this.isAdmin || this.isUnitAdmin || this.isUnitMod || this.isUnitViewer"
            link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="globe" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.jamboree") }}</label>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item v-bind:href="this.routes.members.report.default" v-if="this.isAdmin ||
            this.isUnitAdmin ||
            this.isUnitMod ||
            this.isFinanceAdmin ||
            this.isUnitViewer ||
            this.isTrainingAdmin ||
            this.isTrainMod ||
            this.isTroopAdmin
            " link-classes="white-link row-height">
            <div class="row">
              <div class="col-md-2">
                <b-icon icon="printer" aria-hidden="true" class="float-right"></b-icon>
              </div>
              <div class="col-md-10">
                <label class="float-left font-weight-bold">
                  {{ $t("message.reports") }}</label>
              </div>
            </div>
          </b-nav-item>
        </b-nav>
      </nav>
      <template #footer="{ }">
        <div class="esep-black-bg">
          <b-button class="esep-black-bg mb-5" href="https://topsoftwandtrain.atlassian.net/wiki/spaces/ESEP/overview"
            target="_blank"><b-icon icon="question-circle"></b-icon>
            {{ $t("message.help") }}
          </b-button>
          <b-button class="esep-black-bg mb-5"
            href="https://topsoftwandtrain.atlassian.net/wiki/spaces/ESEP/pages/60358657/Changelog"
            target="_blank"><b-icon icon="gear-fill"></b-icon>
            Changelog
          </b-button>
        </div>
      </template>
    </b-sidebar>
    <div class="col-9 d-flex justify-content-end px-3">
      <div class="row d-flex px-3">
        <div class="col-xs-12 d-flex px-1 justify-content-end" v-if="$keycloak.authenticated">
          <label class="my-auto text-white mr-2" v-if="this.$store.state.userInfo.orgMember != null">
            Καλωσήρθες, {{ this.$store.state.userInfo.orgMember.firstName }} {{
              this.$store.state.userInfo.orgMember.surName
            }}
          </label>
          <b-button @click="$keycloak.logoutFn" class="esep-black-bg" v-b-tooltip.hover :title="$t('message.logout')"
            size="sm">
            <b-icon icon="power" aria-hidden="true"></b-icon></b-button>
        </div>
        <div class="col-md-6 col-xs-12 d-flex px-1 justify-content-end" v-else>
          <b-button @click="$keycloak.loginFn" class="esep-black-bg" v-b-tooltip.hover title="Συνδεθείτε εδώ." size="sm">
            Συνδεθείτε εδώ.
            <b-icon icon="person-circle" aria-hidden="true"></b-icon></b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EsepService from "../services/esep.service.js";
import { routes } from "../services/routing.service";

export default {
  data() {
    return {
      userInfo: {},
      isAdmin: false,
      isUnitAdmin: false,
      isDistrictAdmin: false,
      isFinanceAdmin: false,
      isUnitViewer: false,
      isUnitMod: false,
      seeTrain: false,
      isTrainingAdmin: false,
      isTrainMod: false,
      isTroopAdmin: false,
      isTrainer: false,
      isCommissionPresident: false,
      isCaptain: false,
      isExcursionViewer: false,
      isAffairsCommissioner: false,
      isNavyCommissioner: false,
      isAirCommissioner: false,
      isBranchCommissioner: false,
      routes: routes,
      showTraining: false,
    };
  },
  methods: {
    checkRoles() {
      for (var i = 0; i < this.userInfo.roles.length; i++) {
        if (this.userInfo.roles[i].name == "ADMIN") {
          this.isAdmin = true;
        } else if (this.userInfo.roles[i].name == "UNIT_ADMIN") {
          this.isUnitAdmin = true;
        } else if (this.userInfo.roles[i].name == "FINANCE_ADMIN") {
          this.isFinanceAdmin = true;
        } else if (this.userInfo.roles[i].name == "UNIT_VIEWER") {
          this.isUnitViewer = true;
        } else if (this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.seeTrain = true;
          this.isTrainingAdmin = true;
        } else if (this.userInfo.roles[i].name == "TRAIN_MOD") {
          this.seeTrain = true;
          this.isTrainMod = true;
        } else if (this.userInfo.roles[i].name == "TRAINER") {
          this.seeTrain = true;
          this.isTrainer = true;
        } else if (this.userInfo.roles[i].name == "UNIT_MOD") {
          this.isUnitMod = true;
        } else if (this.userInfo.roles[i].name == "TROOP_ADMIN") {
          this.isTroopAdmin = true;
        } else if (this.userInfo.roles[i].name == "COMMISSION_PRESIDENT") {
          this.isCommissionPresident = true;
        } else if (this.userInfo.roles[i].name == "CAPTAIN") {
          this.isCaptain = true;
        } else if (this.userInfo.roles[i].name == "EXCURSION_VIEWER") {
          this.isExcursionViewer = true;
        } else if (this.userInfo.roles[i].name == "AFFAIRS_COMMISSIONER") {
          this.isAffairsCommissioner = true;
        } else if (this.userInfo.roles[i].name == "NAVY_COMMISSIONER") {
          this.isNavyCommissioner = true;
        } else if (this.userInfo.roles[i].name == "BRANCH_COMMISSIONER") {
          this.isBranchCommissioner = true;
        } else if (this.userInfo.roles[i].name == "AIR_COMMISSIONER") {
          this.isAirCommissioner = true;
        }
      }
    }
  },
  computed: {
    username() {
      return this.$store.state.auth.username;
    },
  },
  mounted() {
    EsepService.getUserInfo(this.username).then((response) => {
      this.userInfo = response.data;
      this.$store.state.userInfo = response.data;
      this.checkRoles();
      let selfLocations = [routes.nothing, routes.home, `${routes.members.member.edit}/${response.data.id}`, `${routes.achievement.progress}/${response.data.id}`, routes.training.evaluation]

      if (this.userInfo.permissions.length < 1 && this.userInfo.roles.length < 1) {
        if (selfLocations.indexOf(location.pathname) < 0) {
          if (this.userInfo.onlySelf) {
            location.replace(`${routes.achievement.progress}/${this.userInfo.id}`);
          }
        }
      }
    },
      (error) => {
        this.errorMessage =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      });
  },
};
</script>

<style>
.the-sidebar {
  background-color: #333645;
  color: white;
}

.the-navbar {
  width: 100%;
}

.white-link {
  color: white;
}

.white-link:hover {
  color: #1565c0
}

.esep-black-bg {
  background-color: #333645;
  border-color: #333645;
}

.row-height {
  height: 48px;
}
</style>